module.exports = __webpack_public_path__ + "img/Gallery_1_16.2023dd2e.jpeg";